import React from "react";
import { Col, Row } from "react-bootstrap";

const IncomeExpenseStatement = ({ incomeData, expensesData }) => {
  return (
    <div>
      <section className="view-data">
        <Row className="main-view-email pt-3">
          <Col md={12} className="text-center">
            <h4 className="mb-4">Income</h4>
          </Col>
          <Col md={6}>
            <Row>
              <Col md={12}>
                <h6 className="mb-4">Gross Income</h6>
              </Col>
              <Col md={6} className="left-name-data">
                <div className="mb-3">
                  <strong className="pe-2">Your Gross Income:</strong>
                  {incomeData?.gross_income?.you || "--"}
                </div>
              </Col>
              <Col md={6} className="left-name-data">
                <div className="mb-3">
                  <strong className="pe-2">Spouse Gross Income:</strong>
                  {incomeData?.gross_income?.spouse_partner || "--"}
                </div>
              </Col>
            </Row>
          </Col>
          <Col md={6}>
            <Row>
              <Col md={12}>
                <h6 className="mb-4">Rent Income</h6>
              </Col>
              <Col md={6} className="left-name-data">
                <div className="mb-3">
                  <strong className="pe-2">Your Rent Income:</strong>
                  {incomeData?.rent_income?.you || "--"}
                </div>
              </Col>
              <Col md={6} className="left-name-data">
                <div className="mb-3">
                  <strong className="pe-2">Spouse Rent Income:</strong>
                  {incomeData?.rent_income?.spouse_partner || "--"}
                </div>
              </Col>
            </Row>
          </Col>
          <Col md={6}>
            <Row>
              <Col md={12}>
                <h6 className="mb-4">Other Income</h6>
              </Col>
              <Col md={6} className="left-name-data">
                <div className="mb-3">
                  <strong className="pe-2">Your Other Income:</strong>
                  {incomeData?.other_income?.you || "--"}
                </div>
              </Col>
              <Col md={6} className="left-name-data">
                <div className="mb-3">
                  <strong className="pe-2">Spouse Other Income:</strong>
                  {incomeData?.other_income?.spouse_partner || "--"}
                </div>
              </Col>
            </Row>
          </Col>
          <Col md={6}>
            <Row>
              <Col md={12}>
                <h6 className="mb-4">Child Support</h6>
              </Col>
              <Col md={6} className="left-name-data">
                <div className="mb-3">
                  <strong className="pe-2">Your Child Support:</strong>
                  {incomeData?.child_support?.you || "--"}
                </div>
              </Col>
              <Col md={6} className="left-name-data">
                <div className="mb-3">
                  <strong className="pe-2">Spouse Child Support:</strong>
                  {incomeData?.child_support?.spouse_partner || "--"}
                </div>
              </Col>
            </Row>
          </Col>
          <Col md={6}>
            <Row>
              <Col md={12}>
                <h6 className="mb-4">SOC, SEC, SSI Income</h6>
              </Col>
              <Col md={6} className="left-name-data">
                <div className="mb-3">
                  <strong className="pe-2">Your Income:</strong>
                  {incomeData?.soc_sec_ssi?.you || "--"}
                </div>
              </Col>
              <Col md={6} className="left-name-data">
                <div className="mb-3">
                  <strong className="pe-2">Spouse Income:</strong>
                  {incomeData?.soc_sec_ssi?.spouse_partner || "--"}
                </div>
              </Col>
            </Row>
          </Col>
          <Col md={6}>
            <Row>
              <Col md={12}>
                <h6 className="mb-4">Pension</h6>
              </Col>
              <Col md={6} className="left-name-data">
                <div className="mb-3">
                  <strong className="pe-2">Your Pension:</strong>
                  {incomeData?.pension?.you || "--"}
                </div>
              </Col>
              <Col md={6} className="left-name-data">
                <div className="mb-3">
                  <strong className="pe-2">Spouse Pension:</strong>
                  {incomeData?.pension?.spouse_partner || "--"}
                </div>
              </Col>
            </Row>
          </Col>
          <Col md={6}>
            <Row>
              <Col md={12}>
                <h6 className="mb-4">Other Misc.</h6>
              </Col>
              <Col md={6} className="left-name-data">
                <div className="mb-3">
                  <strong className="pe-2">Your Other Misc:</strong>
                  {incomeData?.other_misc?.you || "--"}
                </div>
              </Col>
              <Col md={6} className="left-name-data">
                <div className="mb-3">
                  <strong className="pe-2">Spouse Other Misc:</strong>
                  {incomeData?.other_misc?.spouse_partner || "--"}
                </div>
              </Col>
            </Row>
          </Col>
          <Col md={12} className="text-center">
            <h4 className="my-4">Expenses</h4>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Primary Home Mortgage:</strong>
              {expensesData?.primary_home_mortgage || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Primary Home Tax Ins:</strong>
              {expensesData?.primary_home_tax_ins || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Any Other Mortgage:</strong>
              {expensesData?.any_other_mortgage || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Any Other Property Tax Ins:</strong>
              {expensesData?.any_other_property_tax_ins || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Credit Cards Payments total:</strong>
              {expensesData?.credit_card_payments_total || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Any Other Revolving Debt:</strong>
              {expensesData?.any_other_revolving_debt || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Installment Loan Payments:</strong>
              {expensesData?.installment_loan_payments || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Dependent Child Care:</strong>
              {expensesData?.dependent_child_care || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Personal Loans:</strong>
              {expensesData?.personal_loans || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Income Tax From Paycheck:</strong>
              {expensesData?.income_tax_from_paycheck || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">401k Loans:</strong>
              {expensesData?.fourZeroOneKLoans || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Child Support:</strong>
              {expensesData?.child_support || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Alimony:</strong>
              {expensesData?.alimony || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">IRS Liens:</strong>
              {expensesData?.irs_liens || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Tuition:</strong>
              {expensesData?.tuition || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Student Loans:</strong>
              {expensesData?.student_loans || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Gas Expense:</strong>
              {expensesData?.gas || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Electric Expense:</strong>
              {expensesData?.electric || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Water Expense:</strong>
              {expensesData?.water || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Trash Sewer:</strong>
              {expensesData?.trash_sewer || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Telephone Expense:</strong>
              {expensesData?.telephone || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Cell Phone Expense:</strong>
              {expensesData?.cell_phone || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Internet Expense:</strong>
              {expensesData?.internet || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Cable Satellite Expense:</strong>
              {expensesData?.cable_satellite || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Vehicle Insurance:</strong>
              {expensesData?.vehicle_insurance || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Maintenance:</strong>
              {expensesData?.maintenance || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Food Expense:</strong>
              {expensesData?.food || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Transportation:</strong>
              {expensesData?.transportation || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Gardening Misc:</strong>
              {expensesData?.spouse_partner || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Spouse Other Misc:</strong>
              {expensesData?.spouse_partner || "--"}
            </div>
          </Col>
          <Col md={4} className="left-name-data">
            <div className="mb-3">
              <strong className="pe-2">Spouse Other Misc:</strong>
              {expensesData?.spouse_partner || "--"}
            </div>
          </Col>
        </Row>
      </section>
    </div>
  );
};

export default IncomeExpenseStatement;
